document.addEventListener("DOMContentLoaded", function () {
  var slider = document.querySelector(".slider_1");
  if (slider && typeof jQuery !== "undefined" && typeof jQuery(slider).slick === "function") {
    jQuery(slider).slick({
      dots: true,
      prevArrow: '<a class="slick-prev" href="#"><i data-icon="ei-arrow-left" data-size="m"></i></a>',
      nextArrow: '<a class="slick-next" href="#"><i data-icon="ei-arrow-right" data-size="m"></i></a>',
      customPaging: function (slick, index) {
        var targetImage = slick.$slides.eq(index).find("img").attr("src");
        return '<img src="' + targetImage + '"/>';
      }
    });
  }
});
